import { SliceResponse } from '@models/page';
import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

export function getNextPageParam<T>(lastPage: SliceResponse<T>) {
    return lastPage.slice.last ? undefined
        : lastPage.slice.currentPage + 1;
}

export function getFlattenPageResponse<T>(info: UseInfiniteQueryResult<InfiniteData<SliceResponse<T>>>) {
    return info.data?.pages
        ?.map((it) => it.content)
        .flat();
}

export function getIsBlank<T>(info: UseInfiniteQueryResult<InfiniteData<SliceResponse<T>>>) {
    const data = getFlattenPageResponse(info);
    return info.isFetched && data?.length === 0;
}
